import PropTypes from 'prop-types'
import { createContext, useMemo, useCallback } from 'react'
import { jwtDecode } from 'jwt-decode'
// hooks
import useSessionStorage from 'main/hooks/useSessionStorage'
// ----------------------------------------------------------------------

const initialState = {
  token: null,
  user: {},
  setSession: () => {},
}

const SessionContext = createContext(initialState)
SessionProvider.propTypes = {
  children: PropTypes.node
}
function SessionProvider({ children }) {
  const [session, setSession] = useSessionStorage('avista-session', {
    token: null,
    user: {}
  })

  const getRole = useCallback(() => {
    const extractRole = (tokenDecode) => {
      if (Object.prototype.hasOwnProperty.call(tokenDecode, 'role')) {
        if (tokenDecode.role[0] && Object.prototype.hasOwnProperty.call(tokenDecode.role[0], 'code')) {
          return tokenDecode.role[0].code
        }
      }
      if (Object.prototype.hasOwnProperty.call(tokenDecode, 'role_code')) {
        return tokenDecode.role_code
      }
      return null
    }
    
    if (session && session.token) {
      try {
        const tokenDecode = jwtDecode(session.token)
        return extractRole(tokenDecode)
      } catch (e) {
        console.error("Invalid token", e)
        return null
      }
    }
    return null
  }, [session])

  const setDummySession = useCallback(() => {
    setSession({
      ...session,
      token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NDY5NDQ1NTEsImlhdCI6MTY0Njg1ODE1MSwicm9sZV9jb2RlIjoiaW5jb3Jwb3JhdGlvbnMiLCJzdWIiOiJwcnVlYmFzLmJhY2tvZmZpY2UifQ.vfEWHlJ5afD1ptpPASugfHsxGOhiK9t0kdbilUPzeGw",
      user: {username: "pruebas.backoffice"}
    })
  }, [session, setSession])

  const value = useMemo(() => ({
    ...session,
    setSession,
    setDummySession,
    isAuthenticated: (session.token !== null && session.token !== '' ),
    role: getRole(),
  }), [session, setSession, setDummySession, getRole])

  return (
    <SessionContext.Provider
      value={value}
    >
      {children}
    </SessionContext.Provider>
  );
}
export { SessionProvider, SessionContext };